// Package imports:
import React from 'react';
// Component imports:
import Table from 'react-bootstrap/Table';
// Style imports:
// import './AlertOverview.scss';
// Type imports:
import { AlertTickData } from '../../types/api/AlertTypes';
// Utils imports:
import { formatDate } from '../../services/utils';

interface IOwnProps {
    alerts: AlertTickData[]
}
type Props = IOwnProps;

/**
 *  This component displays an overview of alerts. **From Mass Review PopUp**
 *  - Subcomponent of HomeAlertMassReviewModal.tsx
 **/
const AlertOverview: React.FC<Props> = ({
    alerts
}) => {
    return (
        <div id='AlertOverview'>
            <Table className='CompressedTable NotHover'>
                <tbody>
                    <tr id='AlertOverviewHeader'>
                        <th>Symbol</th>
                        <th>Timestamp</th>
                        <th>Alert</th>
                        <th>Status</th>
                    </tr>
                    {alerts.map((alert) => (
                        <tr key={alert.ad_id} id='AlertOverviewBody'>
                            <td>{alert.symbol}</td>
                            <td>{formatDate(alert.timestamp)}</td>
                            <td>{alert.description}</td>
                            <td>{alert.status}</td>
                        </tr>
                    ))}
                </tbody>
            </Table>
        </div>
    )
}

export default AlertOverview;